import { z } from "zod/v4";

import { castToNumber, validateIdNotExponent } from "../utils";

export const ShopifyDuplicateProductVariantSchema = z.object({
  productTitle: z.string(),
  productId: validateIdNotExponent,
  variantTitle: z.string(),
  variantId: validateIdNotExponent,
  price: castToNumber.nullish(),
  comparePrice: castToNumber.nullish(),
  dupProductId: z.string().nullish(),
  dupVariantId: z.string().nullish(),
});

export type ShopifyDuplicateProductVariantType = z.infer<
  typeof ShopifyDuplicateProductVariantSchema
>;
